import { NgModule } from '@angular/core';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';
import { BlogComponent } from './components/blog/blog.component';
import { LandingsComponent } from './components/landings/landings.component';

// const routerOptions: ExtraOptions = {
//     scrollPositionRestoration: 'enabled',
//     anchorScrolling: 'enabled',
//     scrollOffset: [0, 64],
// };

const routes: Routes = [
    {
        // ng g m pages/home --route home --module app.routing
        path: '',
        loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule)
    },
    {
        path: 'como-funciona',
        loadChildren: () => import('./pages/how-it-works/how-it-works.module').then(m => m.HowItWorksModule)
    },
    {
        path: 'tarifas-y-terminos',
        loadChildren: () => import('./pages/rates-and-terms/rates-and-terms.module').then(m => m.RatesAndTermsModule)
    },
    {
        path: 'terminos-y-condiciones',
        loadChildren: () => import('./pages/terms/terms.module').then(m => m.TermsModule)
    },
    {
        path: 'aviso-de-privacidad',
        loadChildren: () => import('./pages/privacy/privacy.module').then(m => m.PrivacyModule)
    },
    {
        path: 'preguntas-frecuentes',
        loadChildren: () => import('./pages/faq/faq.module').then(m => m.FaqModule)
    },
    {
        path: 'contacto',
        loadChildren: () => import('./pages/contact/contact.module').then(m => m.ContactModule)
    },
    {
        path: 'cuestionario2',
        loadChildren: () => import('./pages/cuestionario2/cuestionario2.module').then(m => m.Cuestionario2Module)
    },
    {
        path: 'oferta',
        loadChildren: () => import('./pages/offer/offer.module').then(m => m.OfferModule)
    },
    {
        path: 'landings',
        component: LandingsComponent,
        children: [
            { path: 'credito365', loadChildren: () => import('./pages/landings/credito365/credito365.module').then(m => m.Credito365Module) },
            { path: 'kimbi', loadChildren: () => import('./pages/landings/kimbi/kimbi.module').then(m => m.KimbiModule) },
            { path: 'santander', loadChildren: () => import('./pages/landings/santander/santander.module').then(m => m.SantanderModule) },
            { path: 'santander-fsp', loadChildren: () => import('./pages/landings/santander/santander.module').then(m => m.SantanderModule) },
            { path: 'revolut', loadChildren: () => import('./pages/landings/revolut/revolut.module').then(m => m.RevolutModule) },
        ]
    },
    {
        path: 'prestamos-personales',
        loadChildren: () => import('./pages/prestamos-personales/prestamos-personales.module').then(m => m.PrestamosPersonalesModule)
    },
    {
        path: 'sobre-nosotros',
        loadChildren: () => import('./pages/about/about.module').then(m => m.AboutModule)
    },
    {
        path: 'ofertas',
        loadChildren: () => import('./pages/offerwall/offerwall.module').then(m => m.OfferwallModule)
    },
    {
        path: 'blog',
        loadChildren: () => import('./pages/blog-v2/blog-v2.module').then(m => m.BlogV2Module)
    },
    {
        path: 'redirect',
        loadChildren: () => import('./pages/redirect/redirect.module').then(m => m.RedirectModule)
    },








];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            initialNavigation: 'enabledBlocking',
            scrollPositionRestoration: 'enabled',
            anchorScrolling: 'enabled',
            scrollOffset: [0, 64],
        })
    ],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule { }